import { Trans, useTranslation } from "react-i18next";
import icon from '../../img/TradeTerminal/plus.svg';

const Trade = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px] max-w-[494px]">
                    <Trans
                        i18nKey="terminal.trade.title"
                        components={{ span: <span className="text-[#2A8BFE]" /> }}
                    />
                </h2>
                <div className="flex flex-col sm:grid grid-cols-2 sm:gap-[30px] gap-[13px] mt-[30px] md:mt-[35px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                    <ul className="flex flex-col sm:gap-[15px] gap-[13px]">
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_01')}
                        </li>
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_02')}
                        </li>
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_03')}
                        </li>
                    </ul>
                    <ul className="flex flex-col sm:gap-[15px] gap-[13px]">
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_04')}
                        </li>
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_05')}
                        </li>
                        <li className="flex items-center sm:gap-[18px] gap-[11px]">
                            <img className="sm:w-[32px] w-[18px]" src={icon} alt='' />
                            {t('terminal.trade.li_06')}
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    )
};

export default Trade;
